/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SignalZero = ["svg", defaultAttributes, [["path", { d: "M2 20h.01" }]]];

export { SignalZero as default };
//# sourceMappingURL=signal-zero.js.map
